// @flow
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import SearchResultsItem from './SearchResultsItem';

type Props = {
  results: Array<any>,
  onClickResult: (...args: Array<any>) => any,
  onHoverResult: (...args: Array<any>) => any,
  activeIndex: number | boolean,
  query: string,
  resultItemRef: any,
  resultsScrollContainerRef: any
};

const SearchResultsContainer = (props: Props) => {
  const {
    results,
    onClickResult,
    onHoverResult,
    activeIndex,
    query,
    resultItemRef,
    resultsScrollContainerRef
  } = props;

  return (
    <div className="c-predictive-search-input__results-container">
      <Scrollbars
        autoHeight
        ref={resultsScrollContainerRef}
        autoHeightMax={240}
      >
        {results.map((item, index) => (
          <SearchResultsItem
            resultItemRef={index === 0 ? resultItemRef : null}
            key={index}
            item={item}
            index={index}
            onClickResult={onClickResult}
            onHoverResult={onHoverResult}
            isActive={activeIndex === index}
            query={query}
          />
        ))}
      </Scrollbars>
    </div>
  );
};

export default SearchResultsContainer;
